import throttle           from 'lodash.throttle';

export default class Header {

    static get selector() {
        return '.header';
    }

    constructor(el) {
        this.el = el;
        this.limit = 10;
        this.limitActive = 10;
        this.isFixed = window.pageYOffset > this.limit;
        this.lastScroll = window.pageYOffset;

        this.setEvents();
    }

    /**
     * Events
     */
    
    setEvents() {
        //window.addEventListener('scroll', (e) => { this.e_scroll(e); });

        window.addEventListener('scroll', throttle((e) => {
            this.e_scroll(e);
        }, 50))
    }

    e_scroll(e) {

        // Check if is fixed
        this.isFixed = window.pageYOffset > this.limit;
        if(this.isFixed) {
            this.el.classList.add('header--fixed');
            setTimeout(() => {
                this.el.classList.add('header--animated');
            }, 50);
        } else {
            this.el.classList.remove('header--fixed');
            setTimeout(() => {
                this.el.classList.remove('header--animated');
            }, 400);
        }

        // Cehck if is going up
        if(this.isFixed && window.pageYOffset > this.limitActive ){
            if(this.lastScroll < window.pageYOffset) this.el.classList.remove('header--active');
            else this.el.classList.add('header--active');
        }
        else{
            this.el.classList.remove('header--active');
        }

        // register last scroll
        this.lastScroll = window.pageYOffset;
    }

}

